/**
 * Mod: treasure-hunt
 * Time: 2021-07-22 16:50:57
 */

import request from '@/sdk/fetch'
/**
 * 活动详情
 * @param actid 活动id
 */
export function apiTreasureHuntAct(data = {}) {
  return request.get('/treasure-hunt/act/', data)
}

/**
 * 抽奖
 * @param actid 活动id
 * @param signal 暗号
 * @param treasure 宝藏个数10，20，25对应1，2，3
 */
export function apiTreasureHuntLottery(data = {}) {
  return request.post('/treasure-hunt/lottery/', data)
}

/**
 * 用户信息
 * @param actid 活动id
 */
export function apiTreasureHuntUser(data = {}) {
  return request.get('/treasure-hunt/user', data)
}

/**
 * 用户奖品
 * @param actid 活动id
 */
export function apiTreasureHuntUserPrize(data = {}) {
  return request.get('/treasure-hunt/user-prize', data)
}

/**
 * 用户登记
 * @param actid 活动id
 * @param phone 手机号码
 * @param code code
 */
export function apiTreasureHuntCheckInUser(data = {}) {
  return request.post('/treasure-hunt/check-in-user', data)
}

/**
 * 找宝藏
 * @param actid 活动id
 * @param num 序号
 */
export function apiTreasureHuntTreasure(data = {}) {
  return request.post('/treasure-hunt/treasure', data)
}
